import React from 'react'
import debounce from 'lodash/debounce'
import isEqual from 'lodash/isEqual'

const withAutoSave = ({ debounceTime }) => Component => {
  return class SaveFormik extends React.Component {
    state = {
      isCommitting: false,
      isSaved: false,
      commitError: null,
    }
    componentWillReceiveProps(nextProps) {
      if (!isEqual(nextProps.values, this.props.values)) {
        this.commit()
      }
    }

    commit = debounce(() => {
      this.setState({ isCommitting: true, isSaved: false })
      this.props
        .handleSave(this.props.values)
        .then(
          () => this.setState({ isCommitting: false, isSaved: true }),
          commitError =>
            this.setState({ isCommitting: false, isSaved: true, commitError }),
        )
    }, debounceTime || 500)

    render() {
      return <Component {...this.props} {...this.state} />
    }
  }
}

export default withAutoSave



// WEBPACK FOOTER //
// ./src/modules/form/withAutoSave.js